// src/components/importData/utils/parsers/akbankParser.js
import Papa from 'papaparse';
import { standardizeStockData } from './fileUtils';

export const parseAkbankCSV = async (file) => {
  try {
    const text = await file.text();
    console.log('Raw CSV Content:', text);

    return new Promise((resolve, reject) => {
      Papa.parse(text, {
        delimiter: ';',
        skipEmptyLines: 'greedy',
        encoding: 'windows-1254',
        complete: (results) => {
          try {
            console.log('Initial Parse Result:', results.data);

            const startIndex = results.data.findIndex(row => 
              row.some(cell => cell && cell.includes('Hisse Senetleriniz'))
            );

            if (startIndex === -1) {
              throw new Error('Hisse senedi bölümü bulunamadı');
            }

            const stockRows = results.data.slice(startIndex + 2)
              .filter(row => row.length > 3 && row[0] && row[0].includes('?'));

            console.log('Stock rows before processing:', stockRows);

            const stocks = stockRows.map(row => {
              const rawStock = {
                symbol: row[0]?.replace(/<[^>]*>/g, '').replace(/\s*\?.*$/, '').trim() || '',
                shares: row[1]?.replace(/^="(.*?)"$/, '$1').replace(/"/g, '') || '0',
                price: row[2]?.replace(/^="(.*?)"$/, '$1').replace(/"/g, '') || '0',
                total: row[3]?.replace(/^="(.*?)"$/, '$1').replace(/"/g, '') || '0',
                cost: row[4]?.replace(/^="(.*?)"$/, '$1').replace(/"/g, '') || '0',
                profitLoss: row[5]?.replace(/^="(.*?)"$/, '$1').replace(/"/g, '') || '0'
              };

              return standardizeStockData(rawStock);
            }).filter(stock => stock.symbol && stock.shares > 0);

            if (stocks.length === 0) {
              reject(new Error('İşlenebilir hisse senedi verisi bulunamadı'));
              return;
            }

            resolve(stocks);
          } catch (error) {
            console.error('Processing error:', error);
            reject(error);
          }
        },
        error: (error) => {
          console.error('CSV parsing error:', error);
          reject(error);
        }
      });
    });
  } catch (error) {
    console.error('File reading error:', error);
    throw error;
  }
};